import axios from 'axios';
import { constructServiceURL } from '../../../../utils/URLTools';

const apiFetchUserRole = () => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getUserRole',
    stub: process.env.useStubbedEndpoints,
  });

  return axios.get(serviceUrl);
};

export default {
  apiFetchUserRole,
};
